<template>
	<div class="tabs-bar">
		<div class="tabs-shell">
			<div class="tabs-scroll" role="tablist">
				<button
					v-for="tab in tabs"
					:key="tab.id"
					class="tab-button"
					:class="{ active: tab.id === activeTabId }"
					type="button"
					role="tab"
					:aria-selected="tab.id === activeTabId"
					@click="emit('activate', tab.id)"
				>
					<span class="tab-title">
						<span v-if="tab.icon" class="icon-wrapper">
							<component :is="tab.icon" class="tab-icon" />
						</span>
						{{ tab.title || 'Tab' }}
					</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	tabs: {
		type: Array,
		default: () => [],
	},
	activeTabId: {
		type: String,
		default: null,
	},
});

const emit = defineEmits(['activate']);
</script>

<style scoped>
.tabs-bar {
	padding: 8px 12px 0;
	background: var(--noc-background);
}

.tabs-shell {
	background-color: var(--noc-background-secondary);
	border-radius: 4px;
	padding: 10px;
	margin-bottom: 10px;
	box-shadow: none;
}

.tabs-scroll {
	display: flex;
	gap: 6px;
	overflow-x: auto;
	flex: 1 1 auto;
	scrollbar-width: none;
}

.tabs-scroll::-webkit-scrollbar {
	display: none;
}

.tab-button {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	border-radius: 4px;
	border: 1px solid transparent;
	background: transparent;
	color: var(--text-color-secondary);
	cursor: pointer;
	white-space: nowrap;
	font-weight: 500;
	font-size: 0.9rem;
	transition: all 0.18s ease;
}

.tab-button:hover {
	background: var(--noc-background-secondary);
	color: var(--text-color);
	border-color: transparent;
	transform: none;
	box-shadow: none;
}

.tab-button.active {
	background: var(--noc-blue-05);
	border-color: transparent;
	color: var(--noc-blue);
	box-shadow: none;
}

.tab-title {
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

.icon-wrapper {
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.tab-icon {
	width: 1.15rem;
	height: 1.15rem;
	font-size: 1.15rem;
}

@media (max-width: 768px) {
	.tabs-bar {
		padding: 8px 12px 0;
	}

	.tabs-shell {
		border-radius: 4px;
		padding: 8px;
	}

	.tab-button {
		padding: 8px 12px;
		font-size: 0.9rem;
	}
}
</style>
